<template>
  <div class="hotel-edit-accordion-5">
    <!-- DESCRIÇÃO -->
    <div class="reference-tour" id="form--description">
      <PmwHeading size="paragraph-80" weight="weight-light" class="form--title">
        Descrição
      </PmwHeading>

      <PmwParagraph class="form--info" size="paragraph-40">
        Descreva o hotel de maneira geral, incluindo sua infraestrutura, seus
        diferenciais e os serviços que oferece.
        <br />
        Este texto será exibido em destaque na página do hotel.
      </PmwParagraph>

      <!-- DESCRIÇÃO -->
      <Textarea
        :value="hotelDescription"
        :counter="true"
        :maxlength="4000"
        :hasLanguages="true"
        :language="language"
        label="Descrição"
        placeholder="Digite uma descrição."
        class="form--input form--input__description"
        @changeLanguage="language = $event"
        @input="updateHotelDescription"
      />
    </div>

    <!-- AMENIDADES -->
    <div class="reference-tour" id="form--amenities">
      <PmwHeading size="paragraph-80" weight="weight-light" class="form--title">
        Amenidades
      </PmwHeading>

      <PmwParagraph
        class="form--info form--info__min-spacing"
        size="paragraph-40"
      >
        Defina as amenidades que este hotel oferece no motor de reservas.
      </PmwParagraph>

      <!-- LINK PARA AMENIDADES -->
      <PmwParagraph class="form--info form--info__dark" size="paragraph-40">
        Não encontrou a amenidade?
        <router-link to="/amenidades" class="link" target="_blank"
          >Clique aqui para configurar</router-link
        >
      </PmwParagraph>

      <!-- ADICIONAR AMENIDADES -->
      <PmwSelectionBox
        :value="amenities"
        :list="formattedAmenities"
        titleFirstBox="Adicionar Amenidades"
        selectionPlaceholder="Busque uma amenidade"
        titleSecondBox="Amenidades selecionadas"
        emptySelected="Nenhuma amenidade selecionada para este hotel."
        class="pmw-selection-box"
        @input="$emit('changeAmenities', $event)"
      ></PmwSelectionBox>
    </div>
  </div>
</template>

<script>
import Textarea from '@solucoes/components-lib-tmp/src/components/elements/Textarea'
import PmwHeading from '@solucoes/components-lib-tmp/src/components/elements/PmwHeading'
import PmwParagraph from '@solucoes/components-lib-tmp/src/components/elements/PmwParagraph'
import PmwSelectionBox from '@solucoes/components-lib-tmp/src/components/patterns/PmwSelectionBox'

export default {
  name: 'DescriptionAndAmenities',

  components: {
    Textarea,
    PmwHeading,
    PmwParagraph,
    PmwSelectionBox
  },

  props: {
    amenitiesList: {
      type: Array,
      default: () => []
    },

    description: {
      type: Array,
      default: () => []
    },

    amenities: {
      type: Array,
      default: () => []
    },

    /** Erros (array de erros que foram identificados pelo back-end) */
    errors: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      /** Linguagem selecionada */
      language: 'pt'
    }
  },

  computed: {
    /** Descrição do hotel */
    hotelDescription() {
      return (
        this.description.find((item) => item.idioma.includes(this.language))
          ?.descricao || []
      )
    },

    /** Trazer os dados em português */
    formattedAmenities() {
      const amenities = this.amenitiesList.map((item) => {
        item.text = item.text.find((item) => item.idioma === 'pt-BR')?.nome
        return item
      })
      return amenities
    }
  },

  methods: {
    /** Atualizar o campo de textarea da descrição do hotel
     * @param {String} value: valor do textarea
     */
    updateHotelDescription(value) {
      const foundedItem = this.description.find((item) =>
        item.idioma.includes(this.language)
      )
      if (foundedItem) {
        foundedItem.descricao = value
      }
      this.$emit('changeDescription', this.description)
    }
  }
}
</script>

<style lang="scss" scoped>
.reference-tour {
  position: relative;
}

.pmw-form-field {
  ::v-deep {
    .pmw-form-field--label {
      font-weight: font-weight('weight-medium');
    }
    .form-field--label-wrapper {
      line-height: 21px;
      margin-bottom: 3px;
    }
    .pmw-input {
      background: $white;
    }
    .pmw-input--clear {
      z-index: 0;
    }
    .pmw-input__focus {
      border-color: $pmw-blue;
    }

    .pmw-input--field {
      background: $pmw-white;

      &:focus {
        border-color: $pmw-blue;
      }
    }

    .pmw-custom-tooltip {
      line-height: 18px;
    }
  }
}

.form {
  &--input {
    max-width: 176px;

    /** Alterar cores novas do select */
    ::v-deep {
      .pmw-select--button__caret-sort-up,
      .pmw-select--button__show {
        border-bottom-color: pmw-colors('blue-100');
      }
      .pmw-select--button:focus {
        border-color: pmw-colors('blue-100');
        border-bottom-color: pmw-colors('blue-100');
      }
      .pmw-select-options--item__hover:hover,
      .pmw-select-options--item__checked {
        background-color: pmw-colors('blue-100') !important;
      }

      .pmw-label {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    &__description {
      max-width: 697px;
      margin-bottom: 54px;
    }

    &__select {
      width: 229px;
      max-width: 229px;

      &.error {
        ::v-deep {
          .pmw-select--button {
            border-bottom-color: pmw-colors('error-100');
            border-bottom-width: 2px;
          }
        }
      }
    }
  }

  &--info {
    line-height: 18px;
    margin-bottom: 32px;
    color: $pmw-gray-dark;

    &__min-spacing {
      margin-bottom: 16px;
    }

    &__dark {
      color: pmw-colors('grey-100');
    }

    b {
      font-weight: font-weight('weight-medium');
    }
  }

  &--row {
    display: flex;
    align-items: flex-end;
    flex-wrap: wrap;
    gap: 54px;
    margin-bottom: 54px;
  }

  &--title {
    color: pmw-colors('blue-100');
    font-weight: font-weight('weight-medium');
    margin-bottom: 5px;
    position: relative;
  }
}
.pmw-selection-box {
  margin: 42px 0px 0px 0px;

  ::v-deep {
    .pmw-separate-line {
      display: none;
    }
    span .pmw-icon {
      display: none;
    }
  }
}

.link {
  color: $pmw-blue;

  &:hover {
    color: $pmw-blue;
    text-decoration: underline;
  }
}
</style>
